import { TableCellDefUIDirective } from './directives/table-cell-def.directive';
import { TableColumnDefUIDirective } from './directives/table-column-def.directive';
import { TableHeaderCellDefUIDirective } from './directives/table-header-cell-def.directive';
import { TableHeaderRowDefUIDirective } from './directives/table-header-row-def.directive';
import { TableRowDefUIDirective } from './directives/table-row-def.directive';
import { TableColumnResizeUIDirective } from './directives/table-column-resize.directive';
import { TableCellUIComponent } from './components/table-cell/table-cell.component';
import { TableHeaderCellUIComponent } from './components/table-header-cell/table-header-cell.component';
import { TableHeaderRowUIComponent } from './components/table-header-row/table-header-row.component';
import { TableRowUIComponent } from './components/table-row/table-row.component';
import { TableUIComponent } from './table.component';

/** Everything a template needs to render `<fr8bot-ui-table>` with its column, cell and row defs. */
export const TABLE_UI = [
  TableUIComponent,
  TableCellUIComponent,
  TableHeaderCellUIComponent,
  TableHeaderRowUIComponent,
  TableRowUIComponent,
  TableCellDefUIDirective,
  TableColumnDefUIDirective,
  TableHeaderCellDefUIDirective,
  TableHeaderRowDefUIDirective,
  TableRowDefUIDirective,
  TableColumnResizeUIDirective,
];
